import { render, staticRenderFns } from "./PrivacyPolicyDialog.vue?vue&type=template&id=6d44074b"
import script from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyDialog.vue?vue&type=style&index=0&id=6d44074b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports